import { Stack } from "@mui/material";

import Nav from "./Nav/Index";
import Main from "./Main/Index";
import useResponsive from "@/hooks/useResponsive";
import { createContext, useState } from "react";

export const MyLayoutContext = createContext<{
  navOpen: boolean;
  setNavOpen: (v: boolean) => void;
}>({
  navOpen: false,
  setNavOpen: () => {},
});

export default function Index() {
  const isMobile = !useResponsive("up", "lg");
  const [navOpen, setNavOpen] = useState(false);

  return (
    <Stack
      direction={isMobile ? "column" : "row"}
      flexWrap={isMobile ? "wrap" : "nowrap"}
      component={"main"}
      sx={{ width: 1, minHeight: { lg: 1 } }}
    >
      <MyLayoutContext.Provider
        value={{
          navOpen,
          setNavOpen: (v) => {
            setNavOpen(v);
          },
        }}
      >
        <Nav />
        <Main />
      </MyLayoutContext.Provider>
    </Stack>
  );
}
